import React from "react";

const PackageCard = ({ pkg, selected, onSelect }) => {
  const name = pkg.packageType?.name?.replace(" Package", "") || "";

  return (
    <div
      className={`package-card ${selected ? "selected" : ""}`}
      onClick={onSelect}
    >
      <div className="package-content">
        <div className="package-info">
          <h3>{pkg.packageType?.name}</h3>

          <p>{pkg.packageType?.description}</p>

          <ul>
            <li>
              <i className="fa fa-check"></i>
              Tournament Participation
            </li>

            <li>
              <i className="fa fa-check"></i>
              Match Day Kit
            </li>

            <li>
              <i className="fa fa-check"></i>
              Certificate of Participation
            </li>

            <li>
              <i className="fa fa-check"></i>
              Refreshments
            </li>

            {name !== "Basic" && (
              <li>
                <i className="fa fa-check"></i>
                Player Stats & Ranking
              </li>
            )}

            {name === "Premium" && (
              <>
                <li>
                  <i className="fa fa-check"></i>
                  Awards for Top Performers
                </li>

                <li>
                  <i className="fa fa-check"></i>
                  Media Coverage
                </li>
              </>
            )}
          </ul>
        </div>

        <div className="package-price">
          <h2>₹{pkg.ammount}</h2>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
